export default "__VITE_ASSET__ClU6Dz8u__"